<template>
  <b-row>
    <ServerError v-if="ServerError" />
    <vue-element-loading :active="appLoading" :is-full-screen="true">
      <img src="../../assets/loader.gif" />
    </vue-element-loading>
    <b-col cols="12" xl="12">
      <transition name="slide">
        <b-card>
          <template slot="header">
            <b-row>
              <b-col cols="12" md="4" class="px-4">
                <span><b>Users</b></span>
              </b-col>
            </b-row>
            <b-row class="text-left" align-v="center">
              <b-col cols="12" md="2" class="pt-3">
                <b-dropdown
                  v-if="userRole == 'CityAdmin'"
                  variant="outline-primary"
                  size="md"
                  id="dropdown-1"
                  :text="updateName"
                >
                  <b-dropdown-item
                    v-for="(item, i) in userTypes"
                    :key="i"
                    @click="getData(item)"
                    >{{ item.name }}</b-dropdown-item
                  >
                </b-dropdown>
                <b-dropdown
                  v-else
                  variant="outline-primary"
                  size="md"
                  class="px-4"
                  id="dropdown-1"
                  :text="updateName"
                >
                  <b-dropdown-item
                    v-for="(item, i) in superuserTypes"
                    :key="i"
                    @click="getData(item)"
                    >{{ item.name }}</b-dropdown-item
                  >
                </b-dropdown>
              </b-col>
              <!-- <b-col v-if="updateName == 'Administrators'" cols="2">
                <b-button
                  variant="outline-primary"
                  size="sm"
                  router-link
                  :to="{ name: 'Add Admin', params: { adrole: 'CityAdmin' } }"
                  >Add New Admin</b-button
                >
              </b-col> -->
              <b-col cols="12" md="2">
                <span style="font-size: 12px">Please Select From Date:</span
                ><br />
                <b-form-input
                  class="pt-1"
                  v-model="from"
                  type="date"
                  id="date"
                ></b-form-input>
              </b-col>

              <b-col cols="12" md="2">
                <span style="font-size: 12px">Please Select To Date:</span><br />
                <b-form-input
                  class=""
                  v-model="to"
                  type="date"
                  id="date"
                ></b-form-input>
              </b-col>
              <b-col cols="12" md="6" class="pt-3">
                <b-form @submit.prevent="getSearch">
                  <b-row>
                    <b-col cols="8">
                      <b-form-input
                        list="searchData"
                        v-model="searchKey"
                        placeholder="Search"
                        size="md"
                      ></b-form-input>
                      <!-- <datalist id="searchData">
                        <option v-for="(item,i) in searchData" :key="i">{{item.keyword}}</option>
                      </datalist> -->
                    </b-col>
                    <b-col cols="2" class="pt-1">
                      <b-button
                        variant="outline-primary"
                        size="sm"
                        @click="getSearch"
                        >Search</b-button
                      >
                    </b-col>
                    <b-col cols="1" class="pt-1">
                      <b-button
                        variant="outline-primary"
                        class="px-2"
                        size="sm"
                        @click="getData(userTypes[0])"
                        >All</b-button
                      >
                    </b-col>
                  </b-row>
                </b-form>
              </b-col>
            </b-row>
          </template>
          <b-table
            :hover="true"
            :striped="true"
            :bordered="false"
            :small="false"
            :fixed="false"
            responsive="sm"
            :items="users"
            :fields="fields"
            @row-clicked="rowClicked"
          >
            <template slot="photo" slot-scope="data">
              <img
                v-if="data.item.photo"
                :src="baseURL + '/u/' + data.item.photo"
              />
              <span v-else>-</span>
            </template>
            <template slot="name" slot-scope="data">
              <strong v-if="data.item.name">{{ data.item.name }}</strong>
              <span v-else>-</span>
            </template>
            <template slot="phone" slot-scope="data">
              <span v-if="data.item.phone"
                >{{ data.item.phonePrefix }}&nbsp;{{ data.item.phone }}</span
              >
              <span v-else>-</span>
            </template>
            <template slot="country" slot-scope="data">
              <span v-if="data.item.country">{{ data.item.country }}</span>
              <span v-else>-</span>
            </template>
            <template slot="age" slot-scope="data">
              <span v-if="data.item.age">{{ data.item.age }}</span>
              <span v-else>-</span>
            </template>
            <template slot="gender" slot-scope="data">
              <span v-if="data.item.gender">{{ data.item.gender }}</span>
              <span v-else>-</span>
            </template>
            <template slot="occupation" slot-scope="data">
              <span v-if="data.item.occupation">{{
                data.item.occupation
              }}</span>
              <span v-else>-</span>
            </template>
            <!-- <template slot="_id" slot-scope="data">
              <b-button size="sm" variant="success">View</b-button>
            </template>-->
          </b-table>
          <nav>
            <b-pagination
              size="sm"
              :total-rows="totalUsers"
              :per-page="perPage"
              v-model="currentPage"
              prev-text="Prev"
              next-text="Next"
              @change="nextPage"
            />
          </nav>
          <b-button @click="$router.go(-1)" size="sm">Back</b-button>
        </b-card>
      </transition>
    </b-col>
  </b-row>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      users: [],
      from: null,
      to: null,
      fields: [
        { key: "name", label: "Name", sortable: true },
        { key: "phone", label: "Phone", sortable: false },
        { key: "country", label: "Country", sortable: true },
        { key: "age", label: "Age", sortable: false },
        { key: "gender", label: "Gender", sortable: false },
        { key: "occupation", label: "Occupation", sortable: false },
      ],
      idset:[],
      totalUsers: 0,
      currentPage: 1,
      perPage: 50,
      totalRows: 0,
      appLoading: false,
      ServerError: false,
      updateName: "All Users",
      userTypes: [
        // { name: "All Users", route: "/user/allUsers" },
        { name: "Users", route: "/user/allClients" },
        // { name: "Administrators", route: "/user/allAdmins" },
        { name: "Deactivated Users", route: "/user/bannedusers" },
      ],
      superuserTypes: [
        { name: "All Users", route: "/user/allUsers" },
        { name: "Users", route: "/user/allClients" },
        { name: "Administrators", route: "/user/allAdmins" },
        { name: "Deactivated Users", route: "/user/bannedusers" },
      ],

      currentUser: null,
      searchData: [],
      searchKey: null,
      userRole: localStorage.getItem("role"),
      city: null,
      state: null,
      country: null,
    };
  },
  mounted() {
    this.getProfile();
  },
  methods: {
    nextPage(ev) {
      this.currentPage = ev;
      this.getData(this.currentUser);
    },
    getProfile() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/user/profile",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (this.userRole == "CountryAdmin")
            this.country = response.data.data.country;
          else if (this.userRole == "StateAdmin")
            this.state = response.data.data.state;
          else if (this.userRole == "CityAdmin")
            this.city = response.data.data.city;
          this.getData(this.userTypes[0]);
        })
        .catch((e) => {
          this.ServerError = true;
        });
    },
    getData(item) {
      if (item != this.currentUser) this.currentPage = 1;
      this.currentUser = item;
      this.updateName = item.name;
      this.appLoading = true;
      axios({
        url: item.route,
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          count: this.perPage,
          page: this.currentPage,
          city: this.city,
          country: this.country,
          state: this.state,
        },
      })
        .then((response) => {
          this.users = response.data.data;
           for(var i=0;i<this.users.length;i++)
          { 
            this.idset[i]=this.users[i]._id
          }
          
          this.totalUsers = response.data.count;
          this.appLoading = false;
        })
        .catch((e) => {
          this.ServerError = true;
        });
    },

    // getlastsearches() {
    //   this.appLoading = true;
    //   axios({
    //     url: "/incident/lastsearches",
    //     method: "GET",
    //     headers: {
    //       "x-auth-token": localStorage.getItem("token"),
    //     },
    //     params: {
    //       count: this.perPage,
    //       page: this.currentPage,
    //     },
    //   })
    //     .then((response) => {
    //       this.searchData = response.data.data;
    //       this.totalIncidents = response.data.totalcount;
    //       this.appLoading = false;
    //     })
    //     .catch((e) => {
    //       this.appLoading = false;
    //       this.ServerError = true;
    //     });
    // },
    getSearch() {
      this.appLoading = true;
      if (this.searchKey || (this.from && this.to)) {
        axios({
          method: "GET",
          url: "/search/user",
          headers: {
            "x-auth-token": localStorage.getItem("token"),
          },
          params: {
            // count: this.perPage,
            // page: this.currentPage,
            keyword: this.searchKey,
            type: "User",
            from: this.from,
            to: this.to,
          },
        })
          .then((response) => {
            this.appLoading = false;
            this.users = response.data.data;
            this.totalUsers = response.data.count;
          })
          .catch((err) => {
            this.ServerError = true;
          });
      } else this.getData(this.userTypes[0]);
    },
    rowClicked(item) {
      this.$router.push("/Users/" + item._id +'/'+this.idset);
    },
  },
};
</script>

<style scoped>
.card-body >>> table > tbody > tr > td {
  cursor: pointer;
}
</style>
